import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import {
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Input,
} from "reactstrap"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import { Slide, toast, ToastContainer } from "react-toastify"
import { AvForm } from "availity-reactstrap-validation"
import FileDownload from "js-file-download"
import Select from "react-select"
import Switch from "react-switch"

const OPTIONS = [
  { value: 1, label: "Tous les étudiants" },
  { value: 2, label: "Par groupes" },
  { value: 3, label: "Par un étudiant" },
]
const SEMESTRES = [
  { value: 1, label: "Semestre 1" },
  { value: 2, label: "Semestre 2" },
]

// IMPORTANT : adapter cette route à votre API Laravel si nécessaire.
const ETUDIANTS_PAR_GROUPE_URL = "avis_etudiants/etudiants_par_groupes"
const notifyError = message => toast.error(message, { containerId: "A" })
const notifySuccess = message => toast.success(message, { containerId: "A" })
const normalizeOptions = values => (Array.isArray(values) ? values : [])
const normalizeGroups = value =>
  Array.isArray(value) ? value : value != null && value !== "" ? [value] : []

// Compatible avec les objets react-select, les ID numériques et les objets Laravel.
const getValue = value => {
  if (value == null) return null
  if (typeof value === "object")
    return (
      value.value ?? value.id ?? value.group_td_id ?? value.etudiant_id ?? null
    )
  return value
}
const toOption = (value, possibilities = []) => {
  const id = getValue(value)
  if (id == null || id === "") return null
  const found = normalizeOptions(possibilities).find(
    item => String(getValue(item)) === String(id)
  )
  if (found) return found
  if (typeof value === "object") {
    const label = value.label ?? value.nom_complet ?? value.nom ?? value.libelle
    if (label) return { value: id, label: String(label) }
  }
  // Conserver l'ID lorsque les options de l'API ne le contiennent pas.
  return { value: id, label: String(id) }
}
const parseSelectedIds = value => {
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value)
      return normalizeGroups(parsed)
    } catch (_) {
      return value.includes(",") ? value.split(",").map(v => v.trim()) : [value]
    }
  }
  return normalizeGroups(value)
}

const Offsymbol = () => (
  <div style={{ color: "white", fontSize: 12, textAlign: "center" }}></div>
)
const OnSymbol = () => (
  <div style={{ color: "white", fontSize: 12, textAlign: "center" }}></div>
)

const DataTableAvisEtudiant = props => {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [modal, setModal] = useState(false)
  const [modalNotif, setModalNotif] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [id, setId] = useState("")
  const [file, setFile] = useState(null)
  const fileInputRef = useRef(null)
  const [orders, setOrders] = useState([])
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [status, setStatus] = useState(0)
  const [add, setAdd] = useState(0)
  const [update, setUpdate] = useState(0)
  const [supprimer, setSupprimer] = useState(0)
  const [cloture, setCloture] = useState(0)
  const [cycle, setCycle] = useState([])
  const [selectCycle, setSelectCycle] = useState(null)
  const [niveau, setNiveau] = useState([])
  const [selectNiveau, setSelectNiveau] = useState(null)
  const [selectSemestre, setSelectSemestre] = useState(null)
  const [selectOption, setSelectOption] = useState(null)
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState(null)
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState([])
  const [etudiant, setEtudiant] = useState([])
  const [selectEtudiant, setSelectEtudiant] = useState(null)

  const userAuthScolarite = JSON.parse(
    localStorage.getItem("userAuthScolarite") || "null"
  )
  const annee_id = userAuthScolarite?.user?.annee_id
  const user_id = userAuthScolarite?.user?.id
  const type = selectOption?.value
  const showFormation = type === 2 || type === 3
  const showEtudiant = type === 3
  const { SearchBar } = Search

  const refreshAvis = useCallback(async () => {
    const res = await API.post("avis_etudiants/liste_avis", { annee_id })
    setOrders(normalizeOptions(res.data?.Avis))
  }, [annee_id])

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        setCloture(Number(JSON.parse(localStorage.getItem("cloture") || "0")))
        const menuUsers = JSON.parse(localStorage.getItem("UserMenu") || "[]")
        const menuGroup = menuUsers.find(
          u =>
            Array.isArray(u.sous_menu) &&
            u.sous_menu.some(m => m.sous_menu === "Avis pour les étudiants")
        )
        const menu = menuGroup?.sous_menu.find(
          m => m.sous_menu === "Avis pour les étudiants"
        )
        if (mounted && menu) {
          setAdd(Number(menu.add))
          setUpdate(Number(menu.edit))
          setSupprimer(Number(menu.delete))
        }
        const [avisRes, cyclesRes, niveauxRes] = await Promise.all([
          API.post("avis_etudiants/liste_avis", { annee_id }),
          API.get("cycle/select"),
          API.get("niveau/select"),
        ])
        if (mounted) {
          setOrders(normalizeOptions(avisRes.data?.Avis))
          setCycle(normalizeOptions(cyclesRes.data?.Cycle))
          setNiveau(normalizeOptions(niveauxRes.data?.Niveau))
        }
      } catch (error) {
        console.error("Chargement des avis :", error)
        notifyError("Erreur lors du chargement")
      } finally {
        if (mounted) setLoading(true)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [annee_id])

  const resetFile = () => {
    setFile(null)
    if (fileInputRef.current) fileInputRef.current.value = ""
  }
  const resetForm = () => {
    setId("")
    setSelectOption(null)
    setSelectSemestre(null)
    setSelectCycle(null)
    setSelectNiveau(null)
    setSelectSpecialite(null)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setSpecialite([])
    setGroupe([])
    setEtudiant([])
    resetFile()
    setTitle("")
    setDescription("")
    setStatus(0)
  }
  const changeOption = value => {
    setSelectOption(value)
    setSelectCycle(null)
    setSelectNiveau(null)
    setSelectSpecialite(null)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setSpecialite([])
    setGroupe([])
    setEtudiant([])
  }
  const changeCycle = value => {
    setSelectCycle(value)
    setSelectNiveau(null)
    setSelectSpecialite(null)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setSpecialite([])
    setGroupe([])
    setEtudiant([])
  }
  const changeSemestre = value => {
    setSelectSemestre(value)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setGroupe([])
    setEtudiant([])
    // Les groupes dépendent aussi du semestre : recharger lors du choix de spécialité.
    setSelectSpecialite(null)
  }
  const getSpec = async value => {
    setSelectNiveau(value)
    setSelectSpecialite(null)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setSpecialite([])
    setGroupe([])
    setEtudiant([])
    if (!value || !selectCycle) return
    try {
      const res = await API.post("specialite/get_by_niveau", {
        niveau_id: value.value,
        cycle_id: selectCycle.value,
        annee_id,
      })
      setSpecialite(normalizeOptions(res.data?.specialite))
    } catch (error) {
      console.error(error)
      notifyError("Impossible de charger les spécialités")
    }
  }
  const getGroupe = async value => {
    setSelectSpecialite(value)
    setSelectGroupe([])
    setSelectEtudiant(null)
    setGroupe([])
    setEtudiant([])
    if (!value || !selectCycle || !selectNiveau || !selectSemestre) return
    try {
      const res = await API.post("group/getbyspSem", {
        specialite_id: value.value,
        cycle_id: selectCycle.value,
        niveau_id: selectNiveau.value,
        semestre_id: selectSemestre.value,
        annee_id,
      })
      setGroupe(normalizeOptions(res.data?.groups))
    } catch (error) {
      console.error(error)
      notifyError("Impossible de charger les groupes")
    }
  }
  const getEtudiantsByGroupe = async selectedGroups => {
    const ids = normalizeGroups(selectedGroups)
      .map(getValue)
      .filter(v => v != null)
    if (ids.length === 0) {
      setEtudiant([])
      return
    }
    try {
      const res = await API.post(ETUDIANTS_PAR_GROUPE_URL, {
        group_td_ids: ids,
        annee_id,
        semestre_id: selectSemestre?.value,
      })
      setEtudiant(normalizeOptions(res.data?.Etudiants || res.data?.etudiants))
    } catch (error) {
      console.error(error)
      setEtudiant([])
      notifyError("Impossible de charger les étudiants : vérifiez la route API")
    }
  }
  const changeGroupe = value => {
    setSelectGroupe(value || [])
    setSelectEtudiant([])
    setEtudiant([])
    if (type === 3) getEtudiantsByGroupe(value)
  }

  const validateAvis = editing => {
    if (![1, 2, 3].includes(type))
      return notifyError("Veuillez sélectionner une option"), false
    if (!selectSemestre)
      return notifyError("Veuillez sélectionner un semestre"), false
    if (
      showFormation &&
      (!selectCycle ||
        !selectNiveau ||
        !selectSpecialite ||
        normalizeGroups(selectGroupe).length === 0)
    ) {
      return (
        notifyError("Veuillez compléter cycle, niveau, spécialité et groupe"),
        false
      )
    }
    if (showEtudiant && !selectEtudiant)
      return notifyError("Veuillez sélectionner un étudiant"), false
    if (!title.trim()) return notifyError("Veuillez saisir un titre"), false
    if (!description.trim())
      return notifyError("Veuillez saisir une description"), false
    if (!editing && !file)
      return notifyError("Veuillez sélectionner un fichier PDF"), false
    if (
      file &&
      file.type !== "application/pdf" &&
      !file.name.toLowerCase().endsWith(".pdf")
    ) {
      return notifyError("Le fichier doit être un PDF"), false
    }
    return true
  }
  const buildFormData = () => {
    const data = new FormData()
    data.append("target_type", String(type)) // Le backend doit accepter le type de destinataire.
    data.append("titre", title.trim())
    data.append("contenu", description)
    data.append("annee_id", annee_id)
    data.append("active", status)
    data.append("semestre_id", selectSemestre.value)
    if (showFormation) {
      data.append("cycle_id", selectCycle.value)
      data.append("niveau_id", selectNiveau.value)
      data.append("specialite_id", selectSpecialite.value)
      data.append(
        "group_td_ids",
        JSON.stringify(
          normalizeGroups(selectGroupe).map(group => getValue(group))
        )
      )
    }
    if (showEtudiant)
      data.append(
        "etudiant_ids",
        JSON.stringify(
          normalizeGroups(selectEtudiant).map(group => getValue(group))
        )
      )
    if (file) data.append("fichier", file)
    return data
  }
  const submit = async editing => {
    if (saving || !validateAvis(editing)) return
    setSaving(true)
    try {
      const data = buildFormData()
      if (editing) data.append("id", id)
      const res = await API.post(
        editing ? "avis_etudiants/edit_avis" : "avis_etudiants/add_avis",
        data
      )
      if (Number(res.data?.errNum) !== 200) {
        notifyError(res.data?.message || "Enregistrement non confirmé")
        return
      }
      notifySuccess(
        editing
          ? "Avis étudiant modifié avec succès"
          : "Avis étudiant ajouté avec succès"
      )
      resetForm()
      await refreshAvis()
    } catch (error) {
      console.error(error)
      notifyError("Une erreur est survenue lors de l'enregistrement")
    } finally {
      setSaving(false)
    }
  }
  const save = () => submit(false)
  const edit = () => submit(true)

  const getById = async avisId => {
    try {
      const res = await API.post("avis_etudiants/get_by_id", { id: avisId })
      const avis = res.data?.Avis
      if (!avis) throw new Error("Avis absent de la réponse")

      // Le nom envoyé par buildFormData est "target_type".
      // get_by_id doit retourner ce champ (ou un alias ci-dessous).
      const savedType = Number(
        avis.target_type ?? avis.option ?? avis.type_destinataire
      )
      const choice = OPTIONS.find(item => item.value === savedType)
      if (!choice) {
        notifyError(
          "Le type de destinataire est absent de la réponse get_by_id"
        )
        return
      }

      const currentCycle = toOption(avis.cycle_id, cycle)
      const currentNiveau = toOption(avis.niveau_id, niveau)
      const currentSemestre = toOption(avis.semestre_id, SEMESTRES)

      // Pré-remplir immédiatement les champs communs (sans déclencher
      // les handlers qui réinitialisent les sélections).
      setId(avis.id)
      setSelectOption(choice)
      setSelectSemestre(currentSemestre)
      setTitle(avis.titre || "")
      setDescription(avis.contenu || "")
      setStatus(Number(avis.active) === 1 ? 1 : 0)
      resetFile() // Un input file ne peut pas être prérempli par le navigateur.

      if (savedType === 1) {
        setSelectCycle(null)
        setSelectNiveau(null)
        setSelectSpecialite(null)
        setSelectGroupe([])
        setSelectEtudiant([])
        setSpecialite([])
        setGroupe([])
        setEtudiant([])
        return
      }

      setSelectCycle(currentCycle)
      setSelectNiveau(currentNiveau)
      setSelectSpecialite(null)
      setSelectGroupe([])
      setSelectEtudiant([])
      setSpecialite([])
      setGroupe([])
      setEtudiant([])

      if (!currentCycle || !currentNiveau || !currentSemestre) {
        notifyError("Cycle, niveau ou semestre manquant dans l'avis")
        return
      }

      // Charger d'abord les spécialités pour résoudre la spécialité sauvegardée.
      const specRes = await API.post("specialite/get_by_niveau", {
        niveau_id: currentNiveau.value,
        cycle_id: currentCycle.value,
        annee_id,
      })
      const allSpecs = normalizeOptions(specRes.data?.specialite)
      setSpecialite(allSpecs)
      const currentSpecialite = toOption(avis.specialite_id, allSpecs)
      setSelectSpecialite(currentSpecialite)
      if (!currentSpecialite) return

      // Puis charger les groupes et sélectionner ceux enregistrés.
      const groupRes = await API.post("group/getbyspSem", {
        specialite_id: currentSpecialite.value,
        cycle_id: currentCycle.value,
        niveau_id: currentNiveau.value,
        semestre_id: currentSemestre.value,
        annee_id,
      })
      const allGroups = normalizeOptions(groupRes.data?.groups)
      setGroupe(allGroups)
      const rawGroups = parseSelectedIds(
        avis.group_td_ids ?? avis.group_td_id ?? avis.group_tds
      )
      const selectedGroups = rawGroups
        .map(group => toOption(group, allGroups))
        .filter(Boolean)
      // Le champ Groupe est isMulti pour les options 2 et 3.
      setSelectGroupe(selectedGroups)

      if (savedType === 3 && selectedGroups.length) {
        const studentsRes = await API.post(ETUDIANTS_PAR_GROUPE_URL, {
          group_td_ids: selectedGroups.map(getValue),
          annee_id,
          semestre_id: currentSemestre.value,
        })
        const students = normalizeOptions(
          studentsRes.data?.Etudiants || studentsRes.data?.etudiants
        )
        setEtudiant(students)
        const rawStudents = parseSelectedIds(
          avis.etudiant_ids ?? avis.etudiant_id ?? avis.etudiants
        )
        const selectedStudents = rawStudents
          .map(student => toOption(student, students))
          .filter(Boolean)
        // Le champ Étudiant est isMulti : React-Select attend un tableau.
        setSelectEtudiant(selectedStudents)
      }
    } catch (error) {
      console.error("Chargement pour modification :", error)
      notifyError("Impossible de charger tous les champs de l'avis")
    }
  }
  const toggle = avisId => {
    if (avisId && typeof avisId !== "object") setDeleteId(avisId)
    setModal(current => !current)
  }
  const toggleNotifier = avisId => {
    if (avisId && typeof avisId !== "object") setDeleteId(avisId)
    setModalNotif(current => !current)
  }
  const toggleDelete = async () => {
    if (!deleteId) return
    try {
      await API.post("avis_etudiants/delete_avis", {
        id: deleteId,
        annee_id,
        user_id,
      })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
      notifySuccess("Avis supprimé")
    } catch (error) {
      console.error(error)
      notifyError("Échec de la suppression")
    }
  }
  const toggleNotifierEtd = async () => {
    if (!deleteId) return
    try {
      await API.post("avis_etudiants/send_email", {
        avis_id: deleteId,
        annee_id,
        user_id,
      })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
      notifySuccess("Avis Notifié")
    } catch (error) {
      console.error(error)
      notifyError("Échec de la notification")
    }
  }
  const toggleNotifierRe = async () => {
    if (!deleteId) return
    try {
      await API.post("avis_etudiants/send_email", {
        avis_id: deleteId,
        annee_id,
        user_id,
        force:1
      })
      setModal(false)
      setDeleteId(null)
      await refreshAvis()
      notifySuccess("Avis Notifié")
    } catch (error) {
      console.error(error)
      notifyError("Échec de la notification")
    }
  }
  const download2 = async (avisId, titre) => {
    try {
      const res = await API.post(
        "avis_etudiants/download",
        { id: avisId },
        { responseType: "blob" }
      )
      FileDownload(res.data, `${titre || "avis"}.pdf`)
    } catch (error) {
      console.error(error)
      notifyError("Échec du téléchargement")
    }
  }
  const activeAvis = async row => {
    if (cloture === 1 || update !== 1) return
    try {
      const newStatus = Number(row.active) === 1 ? 0 : 1
      await API.post("avis_etudiants/update_etat", {
        id: row.id,
        active: newStatus,
      })
      await refreshAvis()
      notifySuccess(
        newStatus ? "Avis étudiant activé" : "Avis étudiant désactivé"
      )
    } catch (error) {
      console.error(error)
      notifyError("Impossible de modifier l'état")
    }
  }

  const centered = { textAlign: "center" }
  const Columns = () => [
    {
      dataField: "semestre",
      text: props.t("Semestre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "cycle",
      text: props.t("Cycle"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "niveau",
      text: props.t("Niveau"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "specialite",
      text: props.t("Spécialité"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "group_tds",
      text: props.t("Groupe"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "etudiants",
      text: props.t("Etudiants"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },
    {
      dataField: "titre",
      text: props.t("Titre"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
    },

    {
      dataField: "contenu",
      text: props.t("Description"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      formatter: cell => {
        if (!cell) return ""
        const words = cell.split(" ")
        if (words.length > 7) {
          const firstLine = words.slice(0, 7).join(" ")
          const rest = words.slice(7).join(" ")
          return (
            <>
              {firstLine} <br /> {rest}
            </>
          )
        }
        return cell
      },
    },
    {
      dataField: "notifier",
      text: props.t("Notifier"),
      sort: true,
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#5ad66e", cursor: "pointer" }}
              onClick={() => toggleNotifier(row.id)}
              className="fas fa-bell "
            ></i>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-bell "
              title="L'année est clôturer"
            ></i>
          </div>
        ),
    },
    {
      dataField: "Modifier",
      isDummyField: true,
      text: props.t("Modifier"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "cornflowerblue", cursor: "pointer" }}
                onClick={() => getById(row.id)}
                className="fas fa-edit"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-edit"
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-edit"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
    {
      dataField: "id",
      isDummyField: true,
      text: "Téléchargement",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <a
          onClick={() => download2(row.id, row.titre)}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <i
            style={{ color: "#955cd5", cursor: "pointer" }}
            className="fas fa-file-download"
          ></i>
        </a>
      ),
    },
    {
      dataField: "active",
      isDummyField: true,
      text: "Etat",
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (colIndex, row) =>
        cloture != 1 ? (
          update == 1 ? (
            <Switch
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
            />
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Switch
                title="Vous n'avez pas le droit de modifier l'avis enseignant"
                uncheckedIcon={<Offsymbol />}
                checkedIcon={<OnSymbol />}
                className="me-1 mb-sm-8 mb-2"
                onColor="#34c38f"
                onChange={() => activeAvis(row)}
                checked={row.active}
                disabled={true}
              />
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Switch
              title="Année clôturée"
              uncheckedIcon={<Offsymbol />}
              checkedIcon={<OnSymbol />}
              className="me-1 mb-sm-8 mb-2"
              onColor="#34c38f"
              onChange={() => activeAvis(row)}
              checked={row.active}
              disabled={true}
            />
          </div>
        ),
    },
    {
      dataField: "Suppression",
      isDummyField: true,
      text: props.t("Suppression"),
      style: { textAlign: "center" },
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" }
      },
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) =>
        cloture != 1 ? (
          supprimer == 1 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#ED6464", cursor: "pointer" }}
                onClick={() => toggle(row.id)}
                className="fas fa-trash-alt"
              ></i>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <i
                style={{ color: "#a7a3a3", cursor: "pointer" }}
                className="fas fa-trash-alt"
                title="Vous n'avez pas le droit de supprimer l'avis enseignant"
              ></i>
            </div>
          )
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <i
              style={{ color: "#a7a3a3", cursor: "pointer" }}
              className="fas fa-trash-alt"
              title="Année clôturée"
            ></i>
          </div>
        ),
    },
  ]

  const pageOptions = {
    hidePageListOnlyOnePage: true,
    totalSize: orders.length,
    nextPageText: "Suivant",
    prePageText: "Précédent",
    alwaysShowAllBtns: true,
    sizePerPage: 30,
    sizePerPageList: [
      50,
      100,
      200,
      300,
      { text: "All", value: orders.length || 1 },
    ],
  }
  const NoDataIndication = () => (
    <h6 style={{ textAlign: "center" }}>No record to display</h6>
  )
  return (
    <Fragment>
      {loading ? (
        <Fragment>
          <AvForm>
            <Row>
              <Col lg="4">
                <div className="mb-3">
                  <Label>Choisir une option :</Label>
                  <Select
                    options={OPTIONS}
                    value={selectOption}
                    onChange={changeOption}
                    placeholder="Sélectionner une option"
                    isClearable
                  />
                </div>
              </Col>
              {selectOption && (
                <Col lg="4">
                  <div className="mb-3">
                    <Label>Semestre :</Label>
                    <Select
                      options={SEMESTRES}
                      value={selectSemestre}
                      onChange={changeSemestre}
                      placeholder="Sélectionner le semestre"
                    />
                  </div>
                </Col>
              )}
              {showFormation && (
                <>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Cycle :</Label>
                      <Select
                        options={cycle}
                        value={selectCycle}
                        onChange={changeCycle}
                        placeholder="Sélectionner le cycle"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Niveau :</Label>
                      <Select
                        options={niveau}
                        value={selectNiveau}
                        onChange={getSpec}
                        isDisabled={!selectCycle}
                        placeholder="Sélectionner le niveau"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Spécialité :</Label>
                      <Select
                        options={specialite}
                        value={selectSpecialite}
                        onChange={getGroupe}
                        isDisabled={!selectNiveau || !selectSemestre}
                        placeholder="Sélectionner la spécialité"
                      />
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Groupe :</Label>
                      <Select
                        options={groupe}
                        value={selectGroupe}
                        onChange={changeGroupe}
                        isMulti={type === 2 || type === 3}
                        isDisabled={!selectSpecialite}
                        placeholder="Sélectionner le groupe"
                      />
                    </div>
                  </Col>
                </>
              )}
              {showEtudiant && (
                <Col lg="4">
                  <div className="mb-3">
                    <Label>Étudiant :</Label>
                    <Select
                      options={etudiant}
                      value={selectEtudiant}
                      onChange={setSelectEtudiant}
                      isDisabled={normalizeGroups(selectGroupe).length === 0}
                      placeholder="Sélectionner un étudiant"
                      isSearchable
                      isMulti
                    />
                  </div>
                </Col>
              )}
              {selectOption && (
                <>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Fichier PDF :</Label>
                      <Input
                        innerRef={fileInputRef}
                        type="file"
                        accept=".pdf,application/pdf"
                        className="form-control"
                        onChange={e => setFile(e.target.files?.[0] || null)}
                      />
                      {id && (
                        <small className="text-muted">
                          Laisser vide pour conserver le fichier actuel.
                        </small>
                      )}
                    </div>
                  </Col>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label>Titre :</Label>
                      <Input
                        type="text"
                        className="form-control"
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                        placeholder="Titre"
                      />
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label>Description :</Label>
                      <Input
                        type="textarea"
                        className="form-control"
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        placeholder="Description..."
                      />
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label>État :</Label>
                      <div>
                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          checked={status === 1}
                          className="me-1"
                          onColor="#34c38f"
                          onChange={checked => setStatus(checked ? 1 : 0)}
                        />
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>
            <div className="d-flex justify-content-center gap-2 mt-4">
              {cloture !== 1 && add === 1 && id === "" && selectOption && (
                <Button
                  type="button"
                  color="primary"
                  disabled={saving}
                  onClick={save}
                >
                  {saving ? "Enregistrement..." : props.t("Confirmer")}
                </Button>
              )}
              {cloture !== 1 && update === 1 && id !== "" && (
                <Button
                  type="button"
                  color="warning"
                  disabled={saving}
                  onClick={edit}
                >
                  {saving ? "Enregistrement..." : props.t("Modifier")}
                </Button>
              )}
              {id !== "" && (
                <Button
                  type="button"
                  color="secondary"
                  disabled={saving}
                  onClick={resetForm}
                >
                  {props.t("Annuler")}
                </Button>
              )}
            </div>
          </AvForm>
          <Row className="mt-4">
            <Col xs="12">
              <ToolkitProvider
                keyField="id"
                data={orders}
                columns={Columns()}
                search
                bootstrap4
              >
                {toolkitProps => (
                  <div>
                    <div>
                      <div className="mb-3 row" style={{ display: "flex" }}>
                        <div className="col-md-6 mb-3 row">
                          <div className="col-md-8 search-box-etd">
                            <div
                              className="search-box me-2 mb-2 d-inline-block"
                              style={{ width: "100%" }}
                            >
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      noDataIndication={() => <NoDataIndication />}
                      striped={false}
                      bordered={false}
                      classes={"table align-middle table-nowrap"}
                      headerWrapperClasses={"table-light"}
                      hover
                      pagination={paginationFactory(pageOptions)}
                      {...toolkitProps.baseProps}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Col>
          </Row>
        </Fragment>
      ) : (
        <div className="text-center">
          <Spinner type="grow" color="primary" />
          <h4>{props.t("Chargement")}...</h4>
        </div>
      )}
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId="A"
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
      <Modal isOpen={modal} toggle={() => toggle()} centered>
        <ModalHeader toggle={() => toggle()}>
          {props.t("Suppression")} {props.t("d'avis étudiant")}
        </ModalHeader>
        <ModalBody>
          <p className="text-center">Voulez-vous supprimer cet avis ?</p>
          <div className="d-flex justify-content-around">
            <Button color="info" onClick={toggleDelete}>
              Oui
            </Button>
            <Button color="danger" onClick={() => toggle()}>
              Non
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalNotif} toggle={() => toggleNotifier()} centered>
        <ModalHeader toggle={() => toggleNotifier()}>
          {props.t("Notifier ")} {props.t("d'avis étudiant")}
        </ModalHeader>
        <ModalBody>
          <p className="text-center">Voulez-vous notifier cet avis ?</p>
          <div className="d-flex justify-content-around">
            <Button color="info" onClick={toggleNotifierEtd}>
              Oui
            </Button>
            <Button color="success" onClick={() => toggleNotifierRe()}>
              Réenvoyer
            </Button>
            <Button color="danger" onClick={() => toggleNotifier()}>
              Non
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  )
}

DataTableAvisEtudiant.propTypes = {
  orders: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.func.isRequired,
}
export default withRouter(withTranslation()(DataTableAvisEtudiant))
